// extracted by mini-css-extract-plugin
export default {"container":"SignInButtom_container__Zx5Y8","bodyContainer":"SignInButtom_bodyContainer__gqG7K","arrowPosition":"SignInButtom_arrowPosition__+RXzn"};